import useClosestSilence from "./useClosestSilence";

export default function useSilenceAtPosition(position) {
	const silence = useClosestSilence(position);

	return silence && silence[0] < position && position < silence[1] ? silence : null;
}
